"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIconContainer = exports.ClearInputButton = exports.LabelFiller = exports.AssistiveText = exports.Label = exports.LabelContainer = exports.TextInputContainer = exports.StyledTextWrapper = exports.StyledTextInput = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.StyledTextInput = native_1.default.TextInput `
  flex: 1 0 0;
  min-height: 58px;
  padding: 18px;
  color: ${(p) => p.theme.textInput.color};
  background-color: ${(p) => p.theme.textInput.backgroundColor};
  border: 1px solid ${(p) => p.theme.textInput.borderColor};
  border-radius: ${({ theme }) => theme.textInput.borderRadius || '8px'}
    ${({ shadow, theme }) => shadow &&
    native_1.css `
        shadow-color: ${theme.color.black};
        shadow-offset: 0 0;
        shadow-opacity: 0.11;
        shadow-radius: 7px;
        elevation: 11;
      `}
    ${({ active, theme }) => active &&
    native_1.css `
        border-color: ${theme.color.primary};
      `}
    ${({ success, theme }) => success &&
    native_1.css `
      color: ${theme.textInput.success.color};
      background-color: ${theme.textInput.success.backgroundColor}
      border-color: ${theme.color.state.success};
    `}
    ${({ error, theme }) => error &&
    native_1.css `
        color: ${theme.textInput.error.color};
        background-color: ${theme.textInput.error.backgroundColor};
        border-color: ${theme.textInput.error.borderColor ||
        theme.color.state.error};
      `}
    ${({ clearButtonEnabled }) => clearButtonEnabled &&
    native_1.css `
        padding-right: 48px;
        padding-left: 48px;
      `}
    ${({ errorIconEnabled }) => errorIconEnabled &&
    native_1.css `
        padding-right: 50px;
      `}
    ${({ disabled, theme }) => disabled &&
    native_1.css `
        color: ${theme.textInput.disabled.color};
        background-color: ${theme.textInput.disabled.backgroundColor};
        border-color: ${theme.textInput.borderColor};
      `};
`;
exports.StyledTextWrapper = native_1.default.View `
  min-height: 58px;
  justify-content: center;
`;
exports.TextInputContainer = native_1.default.View `
  min-height: 58px;
`;
exports.LabelContainer = native_1.default.View `
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: ${({ theme }) => theme.textInput.labelPadding || '0 0 0 0'};
`;
exports.Label = native_1.default.Text `
  flex-shrink: 1;
  margin-bottom: 7px;
  font-size: 14px;
  line-height: 24px;
  ${({ bold, theme }) => bold &&
    `
      font-weight: bold;
      color: ${theme.textInput.labelTextColor};
    `}
`;
exports.AssistiveText = native_1.default(exports.Label) `
  align-self: flex-end;
  color: ${({ theme }) => theme.textInput.assistiveTextColor};
`;
exports.LabelFiller = native_1.default.View `
  flex: 1 0 8px;
`;
exports.ClearInputButton = native_1.default.TouchableOpacity `
  position: absolute;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  margin-right: 24px;
  right: 0;
  width: 24px;
  height: 24px;
`;
exports.ErrorIconContainer = native_1.default.View `
  position: absolute;
  justify-content: center;
  align-items: center;
  margin-right: 24px;
  right: 0;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.textInput.error.iconColor || theme.textInput.error.color};
`;
